import React, { useEffect, useState } from "react";
import ResourceExplorer from "../components/ResourceExplorer";

function DownloadPage() {
  const [initialCategory, setInitialCategory] = useState(null);

  useEffect(() => {
    // Get category from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
      setInitialCategory(categoryParam);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-10">
      <ResourceExplorer initialCategory={initialCategory} />
    </div>
  );
}

export default DownloadPage;